import { TblCol } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import FormattedDateWithTimeRenderer from '../../../../core/table/renderers/FormattedDateWithTimeRenderer';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey = '' | 'CoveredEntity' | 'ModifiedDate' | 'ObjectState' | 'Type';

// column spec (map the keys to the column types)
export function providerUsageListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'CoveredEntity', { title: 'CE' });
    tblSpecAddColumn<ColKey>(map, 'Type', {});
    tblSpecAddColumn<ColKey>(map, 'ObjectState', { title: 'Status' });
    tblSpecAddColumn<ColKey>(map, 'ModifiedDate', { title: 'Last Processed' }, FormattedDateWithTimeRenderer);
    return map;
}

// default view
export function providerUsageListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: '',
                cols: ['CoveredEntity', 'ModifiedDate', 'ObjectState', 'Type'],
            },
        ],
        sortby: 'CoveredEntity',
    };
}
